module.exports = __webpack_public_path__ + "c440550223e149975eac6d2530293f99.png";